import { createAction } from 'redux-actions'

import { ADD_EMPLOYER, GET_EMPLOYERS, GET_EMPLOYER_BY_ID } from './constants'
import { getEmployersApi, addEmployerApi, getEmployerByIdApi } from './api'

export const getEmployersAction = createAction(GET_EMPLOYERS, async (params) => getEmployersApi(params))
export const getEmployerByIdAction = createAction(GET_EMPLOYER_BY_ID, async (id) => getEmployerByIdApi(id))
export const addEmployerAction = createAction(ADD_EMPLOYER, async (data) => addEmployerApi(data))
